export const sameChairId = (a, b) => String(a ?? 0) === String(b ?? 0);

export const isAllChairsId = (id) => {
  if (id == null || id === '') return true;
  return String(id) === '0';
};

export const findChairById = (workers, id) => {
  if (isAllChairsId(id) || !Array.isArray(workers)) return null;
  return (
    workers.find(
      (worker) => String(worker.idpoltrona ?? worker.id ?? worker.value) === String(id),
    ) || null
  );
};

